import { render, staticRenderFns } from "./ClipboardCheckOutline.vue?vue&type=template&id=22226517&"
import script from "./ClipboardCheckOutline.vue?vue&type=script&lang=js&"
export * from "./ClipboardCheckOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports